/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_No_DiscountInputs */

const es_admin_billing_batch_no_discount = /** @type {(inputs: Admin_Billing_Batch_No_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin descuento`)
};

const en_admin_billing_batch_no_discount = /** @type {(inputs: Admin_Billing_Batch_No_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No discount`)
};

/**
* | output |
* | --- |
* | "No discount" |
*
* @param {Admin_Billing_Batch_No_DiscountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_no_discount = /** @type {((inputs?: Admin_Billing_Batch_No_DiscountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_No_DiscountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_no_discount(inputs)
	return en_admin_billing_batch_no_discount(inputs)
});
export { admin_billing_batch_no_discount as "admin.billing.batch.no_discount" }